import {Authentication} from './Authentication';

export class Proxy
{
    public readonly type:string;
    public readonly host:string;
    public readonly port:any;
    public readonly auth:Authentication;

    constructor(json:any)
    {
        this.type = json['type'];
        this.host = json['host'];
        this.port = json['port'];
        this.auth = json['auth']? new Authentication(json['auth']):null;
    }
}
